const useScheduledEvents = (blockElement: HTMLElement): void => {
  const events = Array.from(blockElement.querySelectorAll('.scheduled-events__occasion')) as HTMLLIElement[];
  const showAllButton: HTMLButtonElement | null = blockElement.querySelector('.scheduled-events__show-more-button');
  const showAllContainer: HTMLDivElement | null = blockElement.querySelector('.scheduled-events__show-more');

  const showAllEvents = (): void => {
    const hiddenEvents = events.filter((event) => event.hidden);
    hiddenEvents.forEach((event) => {
      if (event.hidden) {
        event.hidden = false;

        // Fade in animation
        event.classList.add('scheduled-events__occasion--fade-in');

        setTimeout(() => {
          event.classList.remove('scheduled-events__occasion--fade-in');
        }, 100);
      }
    });

    // Hide "Show more" button if there are no more hidden pages
    if ( showAllContainer && !showAllContainer.hidden) {
      showAllContainer.hidden = true;
    }
  };

  ///* Handle events */
  const handleShowAllEvent = (): void => {
      showAllEvents();
  };

  /* Initializing and adding event listeners */
  const initialize = (): void => {
    if (showAllButton) {
      showAllButton.addEventListener('click', handleShowAllEvent);
    }
  };

  initialize();
};

const scheduledEventsElements = document.querySelectorAll('.scheduled-events') as NodeListOf<HTMLElement>;
if (scheduledEventsElements.length > 0) {
  scheduledEventsElements.forEach((blockElement) => {
    useScheduledEvents(blockElement);
  });
}
